import { consultationStatusEnum } from "beitary-shared";
import { BSelect } from "components";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface StatusSelectProps {
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
  disabled?: boolean;
}

export const StatusSelect = (props: StatusSelectProps) => {
  const { t } = useTranslation();
  const data = consultationStatusEnum.options.map((o) => ({
    value: o,
    label: t(o),
  }));

  return (
    <BSelect
      {...props}
      required
      data={data}
      nothingFound={t("NOTHING_FOUND")}
    />
  );
};
